import { baseUrl } from "../api";

export const projectsUrl = `${baseUrl}projects/`;
export const projectSectionsUrl = `${baseUrl}project-sections/`;
